import {
  _2D_BARCODE_IMAGE_ID,
  BACK_PLANOGRAM_IMAGE_ID,
  BARCODE_IMAGE_ID,
  BOTTOM_PLANOGRAM_IMAGE_ID,
  FRONT_MARKETING_IMAGE_ID,
  FRONT_PLANOGRAM_IMAGE_ID,
  INGREDIENTS_IMAGE_ID,
  LEFT_MARKETING_IMAGE_ID,
  LEFT_PLANOGRAM_IMAGE_ID,
  OTHER_1_IMAGE_ID,
  OTHER_2_IMAGE_ID,
  OTHER_3_IMAGE_ID,
  PANEL_IMAGE_ID,
  RIGHT_MARKETING_IMAGE_ID,
  RIGHT_PLANOGRAM_IMAGE_ID,
  TOP_PLANOGRAM_IMAGE_ID,
} from 'common/components/product-add/components/constants';

export const PROPERTIES_ERRORS = [
  {
    fieldFullPath: 'ProductName',
    displayName: 'Product Name',
    fullPathDisplayName: 'Product Name',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'ProductDescription',
    displayName: 'Product Description',
    fullPathDisplayName: 'Product Description',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'Gtin',
    displayName: 'GTIN',
    fullPathDisplayName: 'GTIN',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'NetContentsValue',
    displayName: 'Net Contents Value',
    fullPathDisplayName: 'Net Contents Value',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'NetContentsUom',
    displayName: 'Net Contents UOM',
    fullPathDisplayName: 'Net Contents UOM',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'NetContentsStatement',
    displayName: 'Net Contents Statement',
    fullPathDisplayName: 'Net Contents Statement',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'BrickCode',
    displayName: 'Brick Code',
    fullPathDisplayName: 'Brick Code',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'PrimarySize',
    displayName: 'Primary Size',
    fullPathDisplayName: 'Primary Size',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'PrimarySizeUOM',
    displayName: 'Primary Size UOM',
    fullPathDisplayName: 'Primary Size UOM',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'CountryOfOrigin',
    displayName: 'Country of Origin',
    fullPathDisplayName: 'Country of Origin',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'Width',
    displayName: 'Width',
    fullPathDisplayName: 'Width',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'Height',
    displayName: 'Height',
    fullPathDisplayName: 'Height',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'Depth',
    displayName: 'Depth',
    fullPathDisplayName: 'Depth',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'Weight',
    displayName: 'Weight',
    fullPathDisplayName: 'Weight',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'DimensionUOM',
    displayName: 'Dimension UOM',
    fullPathDisplayName: 'Dimension UOM',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'WeightUOM',
    displayName: 'Weight UOM',
    fullPathDisplayName: 'Weight UOM',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldFullPath: 'C1N1',
    displayName: 'C1N1',
    fullPathDisplayName: 'C1N1',
    moduleDisplayName: 'Product Basic Information',
  },
  {
    fieldDisplayName: 'Planogram Image',
    displayName: 'Planogram Image',
    fieldFullPath: 'product_PlanoImage',
    fullPathDisplayName: 'Planogram Image',
    moduleName: 'additionalData',
  },
  {
    fieldDisplayName: 'Additional Image',
    displayName: 'Additional Image',
    fieldFullPath: 'product_AdditionalImage',
    fullPathDisplayName: 'Additional Image',
    moduleName: 'additionalData',
  },
  {
    fieldDisplayName: 'Marketing Image',
    displayName: 'Marketing Image',
    fieldFullPath: 'product_MarketingImage',
    fullPathDisplayName: 'Marketing Image',
    moduleName: 'additionalData',
  },
  {
    fieldDisplayName: 'Document',
    displayName: 'Document',
    fieldFullPath: 'product_Document',
    fullPathDisplayName: 'Document',
    moduleName: 'additionalData',
  },
  {
    fieldDisplayName: 'Total Image',
    displayName: 'Total Image',
    fieldFullPath: 'product_AnyImage',
    fullPathDisplayName: 'Total Image',
    moduleName: 'additionalData',
  },
  {
    fieldDisplayName: 'Brand Name',
    displayName: 'Brand Name',
    fieldFullPath: 'BrandId',
    fullPathDisplayName: 'Brand Name',
    moduleName: 'Product Basic Information',
  },
  {
    fieldDisplayName: 'Product Brand',
    displayName: 'Product Brand',
    fieldFullPath: 'Product_Brand',
    fullPathDisplayName: 'Product Brand',
    moduleName: 'additionalData',
  },
  {
    fieldDisplayName: 'UPC/GTIN',
    displayName: 'UPC/GTIN',
    fieldFullPath: 'Product_UpcGtin',
    fullPathDisplayName: 'At least one UPC/GTIN field',
    errorMessage: 'At least one UPC/GTIN field',
    moduleName: 'additionalData',
  },
];

export const PRODUCT_IMAGERY_DEFAULT_LABELS_BY_LEVEL = {
  Unit: {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front Planogram',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left Planogram',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right Planogram',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back Planogram',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top Planogram',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom Planogram',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1C1',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1L1',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1R1',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
  'Inner Pack': {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front Planogram',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left Planogram',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right Planogram',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back Planogram',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top Planogram',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom Planogram',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1CB',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1LB',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1RB',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
  Case: {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front Planogram',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left Planogram',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right Planogram',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back Planogram',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top Planogram',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom Planogram',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1CA',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1LA',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1RA',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
  'Display Shipper': {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front Planogram',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left Planogram',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right Planogram',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back Planogram',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top Planogram',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom Planogram',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1CP',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1LP',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1RP',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
  'Master Case': {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front Planogram',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left Planogram',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right Planogram',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back Planogram',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top Planogram',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom Planogram',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1CM',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1LM',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1RM',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
  Pallet: {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front Planogram',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left Planogram',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right Planogram',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back Planogram',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top Planogram',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom Planogram',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1CP',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1LP',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1RP',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
};
